var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        width: "20",
        height: "20",
        viewBox: "0 0 48 48",
      },
    },
    [
      _c(
        "linearGradient",
        {
          attrs: {
            id: "hlWX3vESs0eSKhHV_ppbBa_bCu25JrJ39EB_gr1",
            x1: ".081",
            x2: "50.487",
            y1: "2.176",
            y2: "52.582",
            gradientUnits: "userSpaceOnUse",
          },
        },
        [
          _c("stop", {
            attrs: {
              offset: "0",
              "stop-color": "#262626",
              "stop-opacity": "0",
            },
          }),
          _vm._v(" "),
          _c("stop", {
            attrs: {
              offset: "1",
              "stop-color": "#262626",
              "stop-opacity": ".8",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "url(#hlWX3vESs0eSKhHV_ppbBa_bCu25JrJ39EB_gr1)",
          d: "M42.906,33.283c-1.034,2.289-1.529,3.313-2.857,5.336c-1.855,2.825-4.475,6.351-7.714,6.375\tc-2.881,0.024-3.624-1.88-7.534-1.848c-3.91,0.019-4.724,1.883-7.608,1.854c-3.239-0.029-5.718-3.206-7.575-6.026\tc-5.193-7.911-5.741-17.182-2.531-22.116c2.27-3.498,5.864-5.552,9.237-5.552c3.436,0,5.595,1.888,8.436,1.888\tc2.756,0,4.435-1.893,8.409-1.893c3.005,0,6.183,1.637,8.454,4.463C34.195,19.834,35.401,30.444,42.906,33.283z",
        },
      }),
      _vm._v(" "),
      _c(
        "linearGradient",
        {
          attrs: {
            id: "hlWX3vESs0eSKhHV_ppbBb_bCu25JrJ39EB_gr2",
            x1: "17.19",
            x2: "36.29",
            y1: "-4.022",
            y2: "15.078",
            gradientUnits: "userSpaceOnUse",
          },
        },
        [
          _c("stop", {
            attrs: {
              offset: "0",
              "stop-color": "#262626",
              "stop-opacity": "0",
            },
          }),
          _vm._v(" "),
          _c("stop", {
            attrs: {
              offset: "1",
              "stop-color": "#262626",
              "stop-opacity": ".8",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "url(#hlWX3vESs0eSKhHV_ppbBb_bCu25JrJ39EB_gr2)",
          d: "M29.801,8.127c1.428-1.833,2.511-4.418,2.118-7.055c-2.33,0.159-5.054,1.646-6.645,3.573\tc-1.441,1.754-2.637,4.36-2.171,6.881C25.644,11.607,28.274,10.093,29.801,8.127z",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }